import { render } from "./SpaymentReceiptsCreate.vue?vue&type=template&id=14d2d7fc&scoped=true"
import script from "./SpaymentReceiptsCreate.vue?vue&type=script&lang=js"
export * from "./SpaymentReceiptsCreate.vue?vue&type=script&lang=js"

import "./SpaymentReceiptsCreate.vue?vue&type=style&index=0&id=14d2d7fc&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d2d7fc"]])

export default __exports__